module.exports = __webpack_public_path__ + "static/media/Cedric.b48d74dc.png";